var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22418_1291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.195312,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22418_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1973 14.9488L6.04537 17.4088C5.88875 17.4816 5.7453 17.5108 5.61503 17.4964C5.48473 17.482 5.36483 17.4384 5.25533 17.3656C5.14585 17.2928 5.06547 17.1832 5.01419 17.037C4.96289 16.8907 4.9608 16.7468 5.00794 16.6053L6.09737 12.0333L2.43817 8.95512C2.31759 8.85348 2.24275 8.73296 2.21365 8.59355C2.18455 8.45413 2.19009 8.31918 2.23027 8.1887C2.27047 8.0582 2.34532 7.95037 2.45482 7.86521C2.56432 7.78005 2.69599 7.73198 2.84984 7.721L7.64215 7.29657L9.54451 2.93472C9.61381 2.78639 9.70528 2.67684 9.81893 2.6061C9.93259 2.53537 10.0587 2.5 10.1973 2.5C10.3359 2.5 10.4621 2.53537 10.5757 2.6061C10.6894 2.67684 10.7808 2.78639 10.8501 2.93472L12.7525 7.32335L17.5448 7.721C17.6987 7.73198 17.8303 7.78452 17.9398 7.8786C18.0493 7.97269 18.1242 8.08498 18.1644 8.21548C18.2046 8.34596 18.2056 8.47645 18.1675 8.60694C18.1294 8.73742 18.05 8.85348 17.9294 8.95512L14.2973 12.0333L15.3867 16.6053C15.4338 16.7468 15.4318 16.8907 15.3805 17.037C15.3292 17.1832 15.2488 17.2928 15.1393 17.3656C15.0298 17.4384 14.9099 17.482 14.7796 17.4964C14.6493 17.5108 14.5059 17.4816 14.3493 17.4088L10.1973 14.9488Z",
    fill: "#FFF71E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow-star.970cd437edeff75f8b9b4ea43d2d798e.svg";
export { ForwardRef as ReactComponent };